import type { IProductReview } from 'src/types/product';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Rating from '@mui/material/Rating';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import ListItemText from '@mui/material/ListItemText';

import { fDate } from 'src/utils/format-time';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  // TODO: @mfurkankayikci - set prop type
  review: any;
};

export function ProductReviewItem({ review }: Props) {
  // Kullanıcı adı için fallback mantığı
  const userName = review?.createdBy?.displayName || review?.name || 'Anonim Kullanıcı';

  // Avatar için fallback mantığı
  const userAvatar = review?.createdBy?.displayImageUrl || review?.avatarUrl || '';

  const renderInfo = () => (
    <Box
      sx={{
        gap: 2,
        display: 'flex',
        width: { md: 160 },
        alignItems: 'center',
        textAlign: { md: 'center' },
        flexDirection: { xs: 'row', md: 'column' },
      }}
    >
      <Avatar src={userAvatar} sx={{ width: { xs: 48, md: 75 }, height: { xs: 48, md: 75 } }} />

      <ListItemText
        primary={userName}
        primaryTypographyProps={{ noWrap: true, typography: 'subtitle2', mb: 0.5 }}
      />
    </Box>
  );

  const renderContent = () => (
    <Stack spacing={1} flexGrow={1} sx={{ bgcolor: 'background.neutral', p: 3, borderRadius: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Puan:
          </Typography>
          <Rating
            size="small"
            value={review.rating}
            precision={0.1}
            readOnly
            sx={{ color: 'primary.main' }}
          />
        </Stack>

        <Typography variant="body2" fontFamily="Rubik" sx={{ color: 'text.secondary' }}>
          {fDate(review.createdAt)}
        </Typography>
      </Stack>

      {/* <Typography variant="body1" fontWeight={600} fontFamily="Rubik">
        {review.title}
      </Typography> */}
      <Typography variant="body1">{review.comment}</Typography>
    </Stack>
  );

  return (
    <Box
      sx={{
        mt: 5,
        gap: 2,
        display: 'flex',
        px: { xs: 2.5, md: 0 },
        flexDirection: { xs: 'column', md: 'row' },
      }}
    >
      {renderInfo()}
      {renderContent()}
    </Box>
  );
}
